import * as React from 'react';

import { SearchField, Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';

import * as state from '../../_state/financeInvoices.state';

import { useTranslations } from '@/finance/i18n/useTranslations';
import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

//
// ⚛️ ⚛️ ⚛️ INVOICES LIST FILTER BAR ⚛️ ⚛️ ⚛️
//
export const InvoicesListFilterBar = React.memo(() => {
  // Translations
  const t = useTranslations();

  // Atoms
  const [viewMode, setViewMode] = useAtom(state.$viewMode);
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);
  const setOffset = useSetAtom(state.$offset);
  const setSelectedKeys = useSetAtom(state.$selectedKeys);

  // Callbacks
  const handleViewModeChange = React.useCallback(
    (mode: 'flat' | 'grouped') => {
      setViewMode(mode);
      setOffset(0);
      setSelectedKeys(new Set());
    },
    [setViewMode, setOffset, setSelectedKeys],
  );

  const handleSearch = React.useCallback(
    (value: string) => {
      setSearchTerm(value);
      setOffset(0);
    },
    [setSearchTerm, setOffset],
  );

  return (
    <>
      <ToggleButtonGroup
        selectionMode="single"
        disallowEmptySelection
        selectedKeys={[viewMode ?? 'flat']}
        onSelectionChange={(v) =>
          handleViewModeChange(Array.from(v.values())[0] as 'flat' | 'grouped')
        }
      >
        <Toggle className="min-w-23" id="flat">
          {t.invoices.list.viewModes.all}
        </Toggle>
        <Toggle className="min-w-23" id="grouped">
          {t.invoices.list.viewModes.byAccount}
        </Toggle>
      </ToggleButtonGroup>
      <SearchField
        autoFocus
        aria-label={t.invoices.list.search.label}
        className="min-h-0 w-80"
        placeholder={t.invoices.list.search.placeholder}
        value={searchTerm ?? ''}
        onChange={handleSearch}
      />
    </>
  );
});
